import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  config: {},
  loading: true,
  error: true,
  groupTypes: [],
  roles: [],
  isMobile: false,
}

const configSlice = createSlice({
  name: "configSlice",
  initialState,
  reducers: {
    saveConfig: (state, action) => {
      state.config = action.payload.data; 
      state.loading = false;
      state.error = false;
    },
    saveGroupTypes: (state, action) => {
      state.groupTypes = action.payload
    },
    saveRoles: (state, action) => {
      state.roles = action.payload
    },
    saveMobileView: (state, action) => {
      state.isMobile = action.payload
    }
  },

});

export const { saveConfig, saveGroupTypes, saveRoles, saveMobileView } = configSlice.actions;
export default configSlice.reducer;